import { Button, Drawer, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import { UserInfo } from "../../../../context";

const FoodPandaTransaction = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [tranxDetailsList, setTranxDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);
  const [total, setTotal] = useState(0);

  const tableProps = {
    bordered: false,
    size: "medium",
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Qty x Purchase SRP",
      align: "right",
      render: (text, record) => (
        <>
          {text.quantity} x {text.price}
        </>
      ),
    },
    {
      title: "Amount",
      align: "right",
      render: (text, record) => (
        <>
          {parseFloat(
            parseFloat(text.quantity) * parseFloat(text.price)
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].price) * parseFloat(data[i].quantity);
    }
    return total;
  };

  const getSpecTransactionDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      transaction_id: selectedData !== null ? selectedData.transaction_id : "",
    };
    axios
      .get("user/merchant/foodpanda-report/get/spec-transaction", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setTranxDetailsList({ data, ready: true });
        setTotal(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  useEffect(() => {
    getSpecTransactionDetails();
  }, [getSpecTransactionDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Transaction Details"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      }
    >
      {selectedData !== null && (
        <div
          style={{ overflowX: "auto", padding: paddingPrint }}
          ref={componentRef}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {displayDetailsPrint && (
              <Typography.Title style={{ marginBottom: 15 }}>
                Transaction Info
              </Typography.Title>
            )}
            <Typography
              style={{
                fontSize: 14,
              }}
            >
              Transaction Date:{" "}
              <span style={{ fontWeight: "bold" }}>
                {tranxDetailsList.ready &&
                  moment(
                    new Date(tranxDetailsList.data[0].transaction_date)
                  ).format("MMMM DD, YYYY")}
              </span>
            </Typography>

            <Typography
              style={{
                fontSize: 14,
                textTransform: "capitalize",
              }}
            >
              Transaction #:{" "}
              <span style={{ fontWeight: "bold" }}>
                {tranxDetailsList.ready &&
                  tranxDetailsList.data[0].transaction_no}
              </span>
            </Typography>
            <Typography
              style={{
                fontSize: 14,
                textTransform: "capitalize",
              }}
            >
              Customer Name:{" "}
              <span style={{ fontWeight: "bold" }}>
                {tranxDetailsList.ready &&
                  tranxDetailsList.data[0].customer_name}
              </span>
            </Typography>
          </div>

          <Table
            {...tableProps}
            pagination={false}
            columns={tableColumns}
            dataSource={
              tranxDetailsList.data.length > 0 ? tranxDetailsList.data : []
            }
            scroll={scroll}
            rowKey={(record) => record.id}
            footer={() => (
              <div style={{ display: "flex" }}>
                <div style={{ flexGrow: 1, fontWeight: "bold" }}></div>
                Total:{" "}
                {total.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </div>
            )}
          />
        </div>
      )}
    </Drawer>
  );
};

export default FoodPandaTransaction;
